import React, { Component } from 'react';
import { HistoryLayout } from '../../../../common/history/history-layout.component';
import { TablePagination } from '../../../../common/details-table/table-pagination.component';
import { equipmentHistoryActions } from "../../../../../store/external/inventory/history/equipment-history.reducer";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { GDPR_CONFIRMATION_MESSAGE } from "../../../../../constants/external-constants";

class EquipmentHistoryContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
            exportAlertMsg: GDPR_CONFIRMATION_MESSAGE.exportAlertMsg,
        }
    }

    componentDidMount() {
            this.props.getEquipmentHistoryLogs(this.props.equipmentId);
    }

    onClickExtract = () => {
        const { equipmentId, extractEquipmentHistoryLogs } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractEquipmentHistoryLogs(equipmentId);
        }
    }  

    componentWillUnmount() {
        this.props.resetEquipmentHistory();
    }

    getTableData(pageIndex) {
        this.props.getEquipmentHistoryLogs(this.props.equipmentId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeEquipmentHistoryLogs, getEquipmentHistoryLogs, equipmentId } = this.props;
        resizeEquipmentHistoryLogs(pageSize)
        getEquipmentHistoryLogs(equipmentId);
    }

    equipmentPaginationAction = (pageIndex) => {
        const { getEquipmentHistoryLogs, equipmentId } = this.props;
        getEquipmentHistoryLogs(equipmentId, pageIndex);
    }

    onColumnSearch = () => {
        const { getEquipmentHistoryLogs, equipmentId } = this.props;
        getEquipmentHistoryLogs(equipmentId, 0);
    }

    displaySearchBox = (value) =>{
        this.setState({enableSearchBox:value})
    }

    render() {
        const { setEquipmentHistoryColSearchStr, isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;
        const { IsLoadingTable } = this.props.inventoryEquipmentHistory;
        const { Headers, Data, Pagination } = this.props.inventoryEquipmentHistory.HistoryTable;
        return (
            <div>
                <HistoryLayout
                 displaySearchBox={this.displaySearchBox}
                 extractAction={this.onClickExtract}

                 //Access Type
                 isReadOnly={isReadOnly}
                 isReadAndExtractOnly={isReadAndExtractOnly}
                    isReadAndWrite={isReadAndWrite} 
                    hideCustomColumn={true}
                >
                    <TablePagination
                        key="table-pagination-key"
                        columns={Headers}
                        pageList={Data}                 
                        pages={Pagination}
                        paginationAction={this.equipmentPaginationAction}
                        onColumnSearch={() => { this.onColumnSearch() }}
                        onColumnSearchChange={setEquipmentHistoryColSearchStr}
                        isColSearchShow={this.state.enableSearchBox}
                        resizePage={this.resizePage}
                        totalPage={Pagination.TotalEntries}
                        isNotSortable={true}
                        isLoading={IsLoadingTable}    
                    />
                </HistoryLayout>
            </div>
        );
    }
}


export default connect(
    state => {
        const { inventoryEquipmentHistory } = state;

        return {
            inventoryEquipmentHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, equipmentHistoryActions),
        dispatch
    )
)(EquipmentHistoryContainer);
